/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Box } from '@mui/material';

const style = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  padding: '1.1rem 0',
  bgcolor: '#2C313D',
  borderRadius: '5px',
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
  height: '100%',
};

export const ContentContainer = (props) => {
  return <Box sx={{ ...style, ...props.style }}>{props.children}</Box>;
};
